import { render, staticRenderFns } from "./PortalUserBody.vue?vue&type=template&id=56c63b8f&scoped=true&"
import script from "./PortalUserBody.vue?vue&type=script&lang=js&"
export * from "./PortalUserBody.vue?vue&type=script&lang=js&"
import style0 from "./PortalUserBody.vue?vue&type=style&index=0&id=56c63b8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c63b8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAutocomplete,VSnackbar})
